import { render, staticRenderFns } from "./ResourceIndexGroup.vue?vue&type=template&id=4119761c&scoped=true&"
import script from "./ResourceIndexGroup.vue?vue&type=script&lang=js&"
export * from "./ResourceIndexGroup.vue?vue&type=script&lang=js&"
import style0 from "./ResourceIndexGroup.vue?vue&type=style&index=0&id=4119761c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4119761c",
  null
  
)

export default component.exports